import { useState, type PropsWithChildren, useMemo } from "react";

import {
  HotelBookingContext,
  type HotelBookingContextValue,
} from "./HotelBookingContext";

export const HotelBookingContextProvider = ({
  children,
}: PropsWithChildren) => {
  const [data, setData] = useState<HotelBookingContextValue["data"]>(null);
  const [availabilityToken, setAvailabilityToken] = useState<string | null>(
    null,
  );
  const [promoCode, setPromoCode] = useState<string | null>(null);

  const contextValue = useMemo(
    () => ({
      data,
      setData,
      availabilityToken,
      promoCode,
      setPromoCode,
      setAvailabilityToken,
    }),
    [availabilityToken, data, promoCode],
  );

  return (
    <HotelBookingContext.Provider value={contextValue}>
      {children}
    </HotelBookingContext.Provider>
  );
};
